import {
  Button,
  Card,
  Container,
  Stack,
  Switch,
} from '@mui/material';
import React from 'react';
import i18next from 'i18next';

import { useContext } from 'react';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import WebAppSettings from './components/WebAppSettings/WebAppSettings';
import AccessControl from 'Global/security/AccessControl';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import NobatPrefrences from './components/NobatPrefrences/NobatPrefrences';
import useConditionalGrid from 'Global/Hooks/useConditionalGrid';

const DrawerContent = ({ setShowLangEditor }) => {
  const LesserGrid = localStorage.getItem('MoreRows');
  const GlobalConstants = useContext(GlobalContext);
  const isWebAppSettingsEnabled = AccessControl(
    'web-app-setting-accordion'
  );
  const isLanguageEditAllowed = AccessControl(
    'edit-languauge-btn'
  );
  const AccessRoles = GlobalConstants?.AccessRoles;
  const languageSelector_msg = FindLangKey(
    'general-public-setting-language'
  );
  const submit_label = FindLangKey(
    'general-public-btn-save'
  );
  const label_web_app_settings = FindLangKey(
    'genral-public-label-wep-app-settings'
  );
  const confirm_msg = FindLangKey(
    'main-menu-drawer-confirm-message'
  );

  const edit_lang_msg = FindLangKey(
    'personalization-drawer-label-edit-language'
  );
  const selectIconLabel = FindLangKey(
    'general-settings-icon-type'
  );

  const isGrid = useConditionalGrid([{}, {}]);

  return (
    <React.Fragment>
      <Container
        sx={{ mt: '1em' }}
        maxWidth={isGrid ? 'md' : ''}
      >
        <Stack>
          {/* <LanguageSelector />
          <FontSelector />
          <LayoutColorPicker /> */}

          {isWebAppSettingsEnabled &&
          AccessRoles?.includes('admin') ? (
            <Stack gap=".5em">
              <NobatPrefrences />
              <WebAppSettings
                label_web_app_settings={
                  label_web_app_settings
                }
                isLanguageEditAllowed={true}
                AccessRoles={AccessRoles}
                edit_lang_msg={edit_lang_msg}
                submit_label={submit_label}
                setShowLangEditor={setShowLangEditor}
                confirm_msg={confirm_msg}
              />
            </Stack>
          ) : (
            <></>
          )}

          <LanguageSelector
            onChange={() => {}}
            languageSelector_msg={languageSelector_msg}
          />

          {/* <Radioaizer
            direction={i18next.language === "en" ? "row-reverse" : "row"}
            elements={elements}
            initialFunction={useSetIntialThemePrefrence}
            onSelectFunction={HandleSetLayoutColor}
          /> */}

          {/* <LanguageSelector /> */}
          {/* <Stack
            direction={i18next.language === "en" ? "row" : "row-reverse"}
            alignItems="center"
            justifyContent="space-between"
          >
            <p style={{ marginTop: "1em" }}>
              {FindLangKey(
                "personalization-drawer-toggle-display-mode",
                languageArray
              )}
            </p>
            <SwitchToggle onChange={HandleDarkMode} />
          </Stack> */}
          {/* <Stack
            direction={i18next.language === "en" ? "row" : "row-reverse"}
            alignItems="center"
            style={{ marginBlock: "3em" }}
            justifyContent="space-between"
          >
            <p>
              {FindLangKey(
                "general-settings-label-speech-to-text",
                languageArray
              )}
            </p>
            <Stack
              direction={i18next.language === "en" ? "row" : "row-reverse"}
              alignItems="center"
            >
              <p>
                {FindLangKey(
                  "personalization-drawer-label-microphone",
                  languageArray
                )}
                :
              </p>
              <p style={{ marginTop: ".3em" }}>
                {listening ? (
                  <Check sx={{ color: "green" }} />
                ) : (
                  <DoNotDisturb sx={{ color: "red" }} />
                )}
              </p>
            </Stack>
          </Stack>
          <SpeechRecongnitor /> */}
          <Stack
            direction={
              i18next.language === 'en'
                ? 'row'
                : 'row-reverse'
            }
            alignItems="center"
            justifyContent="space-between"
            mt={'0.5em'}
          >
            <p>
              {FindLangKey(
                'general-settings-toggle-more-columns'
              )}
            </p>
            <Switch
              defaultChecked={JSON.parse(LesserGrid)}
              onChange={(e, checked) => {
                GlobalConstants.setMoreColumns(checked);
                localStorage.setItem(
                  'MoreRows',
                  JSON.stringify(checked)
                );
              }}
              sx={{
                fill: `${themeColors.ColorPrimary}`,
                marginLeft: isGrid ? '-.5em' : '',
              }}
            />
          </Stack>
        </Stack>
      </Container>
    </React.Fragment>
  );
};

export default DrawerContent;

// const [voiceEnable, setVoiceEnable] = React.useState(false);
// const { listening } = useSpeechToText(voiceEnable);
// const HandleSetLayoutColor = useHandleLayoutChange();
// const HandleDarkMode = (event, checked) => {
//   if (checked) {
//     document.documentElement.classList.add("dark-mode");
//   } else {
//     document.documentElement.classList.remove("dark-mode");
//   }
// };

// const elements = [
//   <ThemeCard
//     primary={"#88d4d4"}
//     secondary={"#d71a21"}
//     textPersian="123 تست"
//     textEnglish="Test"
//     font="IranYekan"
//   />,
//   <ThemeCard
//     primary={"#3F51B5"}
//     secondary={"#FFC107"}
//     textPersian="123 تست"
//     textEnglish="Test"
//     font="Calibri"
//   />,
//   <ThemeCard
//     primary={"#673AB7"}
//     secondary={"#FF9800"}
//     textPersian="123 تست"
//     textEnglish="Test"
//     font="Tahoma"
//   />,
// ];
